// extracted by mini-css-extract-plugin
module.exports = {"circel":"_3dDhCE_OLaJC7kv958T-Am","typeAvatarNew":"_70Iy9PnREHUG4Uju3Y2iu","boxAvatar":"_2lQNMTBH7SMHKHl6Nrhw05"};